import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/KBNgong";

const KBNgong = () => {
  const projectId = "PRJ00071";
  const title = "KB Ngong";

  const mapConfig = {
    minZoom: 12,
    zoom: 13,
    bounds: [
      [40.73, -74.11],
      [40.67, -73.99],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/plots-in-ngong/achievers-paradise-kimuka-1-b/"
      fillOfferLink="https://forms.gle/hxLRYUAPwsV296nt7"
    />
  );
};

export default KBNgong;
